import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';

@Component({
  selector: 'lib-side-menu-list-item-action',
  imports: [MatListModule, MatIconModule],
  template: `
    <button mat-list-item class="search-options-item" (click)="action.emit()">
      <span matListItemTitle class="mat-label-medium option-label">{{
        title()
      }}</span>
      <span matListItemLine class="mat-label-medium option-desc"
        >{{ subtitle() }}
      </span>
      <mat-icon matListItemIcon class="option-icon">{{ icon() }}</mat-icon>
    </button>
  `,
  styles: `
    @use 'side-menu-list-item' as *;

    @include side-menu-list-item;
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideMenuListItemActionComponent {
  title = input.required<string>();
  subtitle = input<string>();
  icon = input<string>();
  readonly action = output<void>();
}
